<script>
import MasonryCards from '@/components/MasonryCards'

export default {
  name: 'Home',
  components: {
    MasonryCards
  },
  computed: {
    masonryCardData: function() {
      const mcd = [
        {
          title: 'People',
          text: 'People search and edit tool',
          icon_right: 'angle-right',
          icon_right_tooltip: 'Open people search',
          data: {
            name: 'FormSearch',
            params: { formType: 'people' }
          }
        },
        {
          title: 'Roles',
          text: 'Role search and edit tool',
          icon_right: 'angle-right',
          icon_right_tooltip: 'Open role search',
          data: {
            name: 'FormSearch',
            params: { formType: 'roles' }
          },
          permissions: {
            view: { app: 'people', role: 'people' }
          }
        },
        {
          title: 'Groups',
          text: 'Group search and edit tool',
          icon_right: 'angle-right',
          icon_right_tooltip: 'Open group search',
          data: {
            name: 'FormSearch',
            params: { formType: 'groups' }
          },
          permissions: {
            view: [
              { app: 'people', role: 'people' },
              { app: 'people', role: 'people_sys_admin' }
            ]
          }
        },
        {
          title: 'Institutions',
          text: 'Institutions search and edit tool',
          icon_right: 'angle-right',
          icon_right_tooltip: 'Open institutions search',
          data: {
            name: 'FormSearch',
            params: { formType: 'institutions' }
          },
          permissions: {
            view: { app: 'people', role: 'people' }
          }
        },
        {
          title: 'Email Lists',
          text: 'Email lists search and edit tools',
          icon_right: 'angle-right',
          icon_right_tooltip: 'Open email list search',
          data: {
            name: 'FormSearch',
            params: { formType: 'emails' }
          },
          permissions: {
            view: { app: 'people', role: 'people' }
          }
        },
        {
          title: 'Email Moderation',
          text: 'Email moderation distribution tool',
          icon_right: 'angle-right',
          icon_right_tooltip: 'Open email moderation',
          data: {
            name: 'emailModeration'
          },
          permissions: {
            view: { app: 'people', role: 'people' }
          }
        },
        {
          title: 'Applications',
          text: 'Search and edit ARM Applications',
          icon_right: 'angle-right',
          icon_right_tooltip: 'Open applications search',
          data: {
            name: 'FormSearch',
            params: { formType: 'applications' }
          }
        },
        {
          title: 'Reports',
          text: 'People, group, and email list reports',
          icon_right: 'angle-right',
          icon_right_tooltip: 'Open reports list',
          data: {
            name: 'reportList'
          },
          permissions: {
            view: { app: 'people', role: 'people' }
          }
        },
        {
          title: 'Review',
          text:
            'Review my profile and request updates to groups and email lists that I own or add new ARM staff member',
          icon_right: 'angle-right',
          icon_right_tooltip: 'Open my reviews',
          data: {
            name: 'myReview'
          }
        },
        {
          title: 'Field Campaign Subscriptions',
          text: 'Manage my Field Campaign email list subscriptions.',
          icon_right: 'angle-right',
          icon_right_tooltip: 'Open my Field Campaign Subscriptions',
          data: {
            name: 'fcSubscriptions'
          }
        }
      ]
      return mcd.filter(mc => this.hasElementPermissions(mc, 'view'))
    }
  },
  methods: {
    goToSite(data) {
      this.$router.push(data)
    }
  }
}
</script>

<template>
  <div>
    <transition name="y-slide" mode="out-in">
      <div :key="masonryCardData.length">
        <MasonryCards :content="masonryCardData" @bodyClick="goToSite" />
      </div>
    </transition>
  </div>
</template>

<style scoped></style>
